module.exports = __webpack_public_path__ + "img/49.53d9a89d.png";